import type { RoutePath } from '@/lib/wizard/wizard';

import { trackCioEvent } from '../cio';
import { AnalyticsEvent } from '../types';

export type SessionResumedEventProperties = {
  resume_path: RoutePath;
};

export function trackSessionResumed(properties: SessionResumedEventProperties) {
  trackCioEvent(AnalyticsEvent.SESSION_RESUMED, properties);
}
